import Option from '../../shared/styledComponents/Option';
import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent';

export default InjectedStyledComponent(Option, 'selectionField', ['option']);